import CloseIcon from 'assets/icons/close-dark.svg';
import Logo from 'assets/logo.svg';
import classnames from 'classnames';
import SpaLink from 'components/SpaLink/SpaLink';
import { NavigationLabel } from 'frontend/enums';
import { CategoryItem } from 'frontend/types';
import { primaryNavigationClick } from 'frontend/utils/analytics/dataLayerDispatchers';
import useDialogTabTrap from 'frontend/utils/hooks/useDialogTabTrap';
import { useRouter } from 'next/router';
import { useEffect, useRef, useState } from 'react';
import CategoriesMenu from './components/CategoriesMenu/CategoriesMenu';
import NavDropdown from './components/NavDropdown/NavDropdown';
import styles from './PrimaryNavigation.module.css';
import Search from 'icons/search_white.svg';
type PrimaryNavigationProps = {
  categoryMenuItems: CategoryItem[];
  minorityLanguageCategories: CategoryItem[];
  hideMenu: () => void;
  isMenuOpen: boolean;
};
const PrimaryNavigation = ({
  categoryMenuItems,
  hideMenu,
  isMenuOpen,
  minorityLanguageCategories
}: PrimaryNavigationProps) => {
  const [categoriesMenuOpen, setCategoriesMenuOpen] = useState(false);
  const router = useRouter();
  const handleDropdown = () => {
    if (!categoriesMenuOpen) {
      setCategoriesMenuOpen(true);
      primaryNavigationClick('Kategorier');
    } else {
      setCategoriesMenuOpen(false);
    }
  };
  const mobileMenuRef = useRef<HTMLDivElement>(null);
  useDialogTabTrap(isMenuOpen, mobileMenuRef, hideMenu);
  useEffect(() => {
    if (isMenuOpen) {
      mobileMenuRef.current?.focus();
    }
  }, [isMenuOpen]);
  const currentFullPath = router.asPath;
  return <nav aria-label="Huvudmeny" className={styles.navigation} tabIndex={-1} {...isMenuOpen ? {
    ref: mobileMenuRef
  } : {}} data-sentry-component="PrimaryNavigation" data-sentry-source-file="PrimaryNavigation.tsx">
      <ul className={classnames('menu', styles.menuWrapper)}>
        <li className={styles.logoItem}>
          <div className={styles.mobileCloseButtonContainer}>
            <button onClick={hideMenu} className={styles.mobileCloseButton} aria-label="Stäng huvudmeny" aria-controls="Huvudmeny" aria-expanded={isMenuOpen}>
              <CloseIcon aria-hidden focusable="false" className={styles.closeIcon} data-sentry-element="CloseIcon" data-sentry-source-file="PrimaryNavigation.tsx" />
            </button>
          </div>
          <SpaLink href="/" className={styles.logoLink} data-trk-primary-navigation="Logo" onClick={() => primaryNavigationClick('Start')} data-sentry-element="SpaLink" data-sentry-source-file="PrimaryNavigation.tsx">
            <Logo className={styles.logo} focusable="false" role="img" aria-label="UR Play" data-sentry-element="Logo" data-sentry-source-file="PrimaryNavigation.tsx" />
          </SpaLink>
        </li>
        <li data-testid="category-nav" className={classnames(styles.navItem, styles.categoriesNavItemDesktop)}>
          <NavDropdown currentFullPath={currentFullPath} handleDropdown={handleDropdown} isOpen={categoriesMenuOpen} label={NavigationLabel.CATEGORIES} data-sentry-element="NavDropdown" data-sentry-source-file="PrimaryNavigation.tsx">
            <CategoriesMenu closeMenu={() => setCategoriesMenuOpen(false)} categoryMenuItems={categoryMenuItems} minorityLanguageCategories={minorityLanguageCategories} isOpen={categoriesMenuOpen} data-sentry-element="CategoriesMenu" data-sentry-source-file="PrimaryNavigation.tsx" />
          </NavDropdown>
        </li>
        <li>
          <SpaLink href="/bladdra/alla-kategorier" className={classnames(styles.navItem, styles.categoriesNavItemMobile)} onClick={() => primaryNavigationClick('Alla kategorier')} data-sentry-element="SpaLink" data-sentry-source-file="PrimaryNavigation.tsx">
            Kategorier
          </SpaLink>
        </li>
        <li data-testid="education-nav" className={styles.navItem}>
          <SpaLink href="/utbildning" className={styles.headerNavigation} data-trk-primary-navigation="Lärare" onClick={() => primaryNavigationClick('Lärare')} data-sentry-element="SpaLink" data-sentry-source-file="PrimaryNavigation.tsx">
            Lärare
          </SpaLink>
        </li>
        <li data-testid="children-nav" className={styles.navItem}>
          <SpaLink href="/barn" className={styles.headerNavigation} data-trk-primary-navigation="Barn" onClick={() => primaryNavigationClick('Barn')} data-sentry-element="SpaLink" data-sentry-source-file="PrimaryNavigation.tsx">
            Barn
          </SpaLink>
        </li>
        <li className={classnames(styles.navItem, styles.myPageNavItem)}>
          <SpaLink href="/min-sida" className={styles.headerNavigation} data-trk-my-page="navigationslänk" onClick={() => primaryNavigationClick('Min sida')} data-sentry-element="SpaLink" data-sentry-source-file="PrimaryNavigation.tsx">
            Min sida
          </SpaLink>
        </li>
        <li className={classnames(styles.navItem, styles.searchItem)}>
          <SpaLink href="/sok" onClick={() => primaryNavigationClick('Sök')} className={styles.searchLink} data-hidden-in-tabtrap data-sentry-element="SpaLink" data-sentry-source-file="PrimaryNavigation.tsx">
            Sök
            <Search aria-hidden data-sentry-element="Search" data-sentry-source-file="PrimaryNavigation.tsx" />
          </SpaLink>
        </li>
      </ul>
    </nav>;
};
export default PrimaryNavigation;